import {
  CalendarOutlined,
  DollarOutlined,
  SolutionOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Button, Card, message, Statistic } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { LuDownload } from "react-icons/lu";
import { API } from "../../../../config/Api";
import { GET, POST } from "../../../../utils/apiRequest";
import CustomModal from "../../../components/customModal/customModal";
import TransactionSettle from "./transactionSettle";
import { InvoiceTemplate } from "../../../../utils/template";

const Transactions = (props: any) => {
  const [transactions, setTransactions] = useState([]);
  const [totalDueAmount, setTotalDueAmount] = useState(0);
  const [totalPaidAmount, setTotalPaidAmount] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeModal, setActiveModal] = useState<any>(null);
  const [selectedTransactionId, setSelectedTransactionId] = useState(null);
  const [loadingTransactionId, setLoadingTransactionId] = useState<string>("");

  useEffect(() => {
    fetchTransactions();
  }, [props?.id,props?.reloadTrigger]);

  const fetchTransactions = async () => {
    try {
      const requestPayload = {
        user_id: props?.id,
      };

      const response: any = await POST(
        `${API.LIST_USER_TRANSACTIONS}?order=ASC&page=1&take=100`,
        requestPayload
      );

      if (response?.status) {
        const transactionsData = response?.data?.[0] || [];
        const summary = response?.data?.[1] || {};

        setTransactions(transactionsData);
        setTotalDueAmount(summary?.total_due || 0);
        setTotalPaidAmount(summary?.total_paid || 0);
      } else {
        message.error("Failed to fetch transactions");
      }
    } catch (error) {
      console.error(error);
      message.error("An error occurred while fetching transactions.");
    }
  };

  const handleDeleteTransaction = async (remark: any) => {
    if (!selectedTransactionId) return;

    try {
      const deleteUrl = `${API.TRANSACTION_DELETE}`;
      const response: any = await POST(deleteUrl, {
        id: selectedTransactionId,
        remark,
      });
      if (response?.status) {
        message.success(
          response?.message || "Transaction deleted successfully"
        );
        fetchTransactions();
      } else {
        message.error(response?.message || "Failed to delete transaction");
      }
    } catch (error) {
      console.error(error);
      message.error("An error occurred while deleting the transaction.");
    } finally {
      closeModal();
    }
  };

  const openModal = (id: any) => {
    setSelectedTransactionId(id);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedTransactionId(null);
  };

  const isPaid = totalPaidAmount >= totalDueAmount;

  const handleDownload = async (transaction_id: string) => {
    try {
      setLoadingTransactionId(transaction_id);
      const response: any = await GET(
        `${API.GET_INVOICE_DETAILS}${transaction_id}`,
        null
      );

      if (response?.status && response?.data) {
        const templateContent = InvoiceTemplate(response.data)
          .replace(/\r\n/g, "")
          .replace(/\\"/g, '"');

        const pdfRequestData = {
          filename: "Transaction Invoice",
          html: btoa(unescape(encodeURIComponent(templateContent))),
          isDownload: true,
          sendEmail: false,
          type: "",
          userid: "",
        };

        const pdfResponse = await fetch(API.PDF_GENERATE_URL, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(pdfRequestData),
        });

        if (!pdfResponse.ok) {
          throw new Error(`HTTP error! Status: ${pdfResponse.status}`);
        }

        // For web browser download
        const blob = await pdfResponse.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Invoice_${moment().format("YYYY/MM/DD_HH-mm-ss")}.pdf`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        message.success("Invoice downloaded successfully");
        if (props.invoiceOk) {
          props.invoiceOk(true);
        }
      } else {
        message.error("Failed to generate invoice");
      }
    } catch (error) {
      console.error("Error downloading invoice:", error);
      message.error("Failed to download invoice");
    } finally {
      setLoadingTransactionId("");
    }
  };
  return (
    <div>
      <div className="col-12 col-lg-6">
        <Card
          title="Payment Summary"
          style={{
            backgroundColor: isPaid ? "#f6ffed" : "#fff2f0",
          }}
        >
          <Row>
            <Col md={6}>
              <Statistic
                title="Due Amount"
                value={totalDueAmount}
                prefix="₹"
                valueStyle={{ color: "red" }}
              />
            </Col>
            <Col md={6} className="text-start text-sm-end">
              <Statistic
                title="Paid Amount"
                value={totalPaidAmount}
                prefix="₹"
                valueStyle={{ color: isPaid ? "green" : "inherit" }}
              />
            </Col>
            <Col className="text-end mt-2">
              {totalDueAmount > 0 && (
                <Button
                  className="text-danger"
                  onClick={() => setActiveModal("settleDue")}
                >
                  Settle Due
                </Button>
              )}
            </Col>
          </Row>
        </Card>
      </div>

      <br />

      {transactions?.map((item: any, index) => (
        <Card key={index} className="col-12 col-lg-6 mb-3">
          <Row>
            <Col md={6}>
              <div>
                <UserOutlined className="me-2" />
                <strong>{item?.["user.name"] ?? "Unknown User"}</strong>
              </div>
              <br />
              <div>
                <CalendarOutlined className="me-2" />
                <strong>
                  {moment(item?.createdAt).format("YYYY/MM/DD h:mm A")}
                </strong>
              </div>
            </Col>
            <Col md={6} className="text-start text-sm-end">
              <div>
                <SolutionOutlined className="me-2" /> {item?.by || ""}
              </div>
              <br />
              <div style={{ fontWeight: "bold" }}>
                Amount: {item?.total_amount?.toLocaleString() || "0"}
              </div>
            </Col>
          </Row>
          <hr />
          <div className="d-flex justify-content-between">
            <div>
              {/* <DollarOutlined className="me-2" /> */}
              ₹ 
              <span>Paid Amount</span>
            </div>
            <div>
              <strong>₹{item?.paid_amount?.toLocaleString() || 0} /-</strong>
            </div>
          </div>
          <div className="mt-3 d-flex justify-content-between">
            <Button
              className="d-flex align-items-center"
              loading={loadingTransactionId === item?.transaction_id}
              onClick={() => handleDownload(item?.transaction_id)}
            >
              <LuDownload size={20} />
            </Button>
            <Button
              type="primary"
              danger
              onClick={() => openModal(item?.transaction_id)}
            >
              Delete
            </Button>
          </div>
        </Card>
      ))}

      {activeModal === "settleDue" && (
        <TransactionSettle
          isModalOpen={Boolean(activeModal)}
          handleCancel={() => setActiveModal(null)}
          data={props?.data}
          due={totalDueAmount}
          reload={fetchTransactions}
        />
      )}

      {isModalOpen && (
        <CustomModal
          isModalOpen={isModalOpen}
          handleCancel={closeModal}
          title="Transaction"
          type="Delete"
          onDelete={handleDeleteTransaction}
        />
      )}
    </div>
  );
};

export default Transactions;
